import { axios } from '@/common/api.service.js'
import refreshCombatantOrder from '../../helpers/refreshCombatantOrder'

console.log('HERE CombatJS')

const APP_SETTINGS_KEYS = [
  'debug',
  'log_notifications',
  'sockets',
  'auto_apply_overloading_adjs',
  'auto_sr_roll_troops',
  'auto_sr_roll_chars',
  'auto_sr_roll_npcs',
  'auto_sr_roll_monsters',
  'auto_troop_roll_offs',
  'auto_start_new_round',
  'prompt_keep_sr_rolls',
]

function mergeConfigWithAppSettings(config, appSettings) {
  if (!config) {
    return config
  }

  if (!appSettings) {
    return config
  }

  const overrides = APP_SETTINGS_KEYS.reduce((resolvedOverrides, key) => {
    if (Object.prototype.hasOwnProperty.call(appSettings, key)) {
      resolvedOverrides[key] = appSettings[key]
    }

    return resolvedOverrides
  }, {})

  return {
    ...config,
    ...overrides,
  }
}
//===============================================================
// state
//--------
const state = () => ({
  //
  isCombat: false,
  //
  view_round: 0,
  arena_sub_status: '',
  unused_action_count: 0,
  current_action_number: 0,
  //
  config: null,
  appSettings: null,
  arena: null,
  //
  arenas: [],
  players: [],
  player_names: [],
  races: [],
  roles: [],
  statuses: [],
  markers: [],
  options: [],
  visibilities: [],
  actions: [],
  reactions: [],
  characters: [],
  //
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})
//===============================================================
// getters
//---------
const getters = {
  //
  getCurrentActionNumber(state) {
    return state.current_action_number
  },
  getUnusedActionCount(state) {
    return state.unused_action_count
  },
  getCampaignLockStatus: (state) => (arena_id) => {
    console.log('IN getCampaignLockStatus')
    let arena = state.arenas.find((a) => a.id == arena_id)

    if (arena) {
      console.log('IN getCampaignLockStatus MATCH = ' + arena.locked + ' slug = ' + arena.slug)
      return arena.locked
    } else {
      console.log('IN getCampaignLockStatus NO MATCH')
      return null
    }
  },
  getMarkers(state) {
    return state.markers
  },
  getOptions(state) {
    return state.options
  },
  getStatuses(state) {
    return state.statuses
  },
  getVisibilities(state) {
    return state.visibilities
  },
  getFatigues(state) {
    return state.fatigues
  },
  getActions(state) {
    return state.actions
  },
  getReactions(state) {
    return state.reactions
  },
  // getRaces(state) {
  //   return state.races;
  // },
  getRoles(state) {
    return state.roles
  },
  getCombatants(state) {
    return state.arena.arena_combatants
  },
  getActiveCombatants(state) {
    if (state.arena && state.arena.arena_combatants) {
      return state.arena.arena_combatants.filter((c) => c.status == 'Active')
    }
  },
  getActiveCombatantCount(state) {
    if (state.arena && state.arena.arena_combatants) {
      return state.arena.arena_combatants.filter((c) => c.status == 'Active').length
    } else {
      return 0
    }
  },
  getInactiveCombatantCount(state) {
    if (state.arena && state.arena.arena_combatants) {
      return state.arena.arena_combatants.filter((c) => c.status == 'Inactive').length
    } else {
      return 0
    }
  },
  getPlayerNames(state) {
    return state.player_names
  },
  getCampaignPlayers(state) {
    return state.players
  },
  getCampaign(state) {
    return state.arena
  },
  getCampaignName(state) {
    if (state.arena) {
      return state.arena.name
    }
  },
  getConfig(state) {
    return mergeConfigWithAppSettings(state.config, state.appSettings)
  },
  getAppSettings(state) {
    return state.appSettings
  },
  getVersion(state) {
    if (state.config) {
      return state.config.version
    } else {
      return ''
    }
  },
  getHeaders(state) {
    return state.headers
  },
  getViewRound(state) {
    return state.view_round
  },
  getArenaSubStatus(state) {
    return state.arena_sub_status || ''
  },
  isPlayer(state, getters, rootState, rootGetters) {
    const getUserProfile = rootGetters['auth/getUserProfile']
    if (state.arena.dm.user_name !== getUserProfile.user_name) {
      return true
    } else {
      return false
    }
  },
}
//=================================================================
// actions
//---------
const actions = {
  //===============================================================
  // store access token
  //------------------
  storeAxiosAuthToken({ commit }, payload) {
    commit('setAccessToken', payload)
  },
  //===============================================================
  // clear debug log
  //-----------------
  async clearDebugLog() {
    const endpoint = 'cleardebuglog/'
    const headers = state.headers
    await axios
      .post(endpoint, null, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then(() => {})
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        if (err?.response?.status === 403) {
          return null
        }
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // list all/my arenas
  //--------------------
  async listArenas({ commit, state }, endpoint) {
    const headers = state.headers
    return new Promise((resolve, reject) => {
      axios
        .get(endpoint, {
          headers: headers,
          mode: 'same-origin',
        })
        //----------
        // where ok
        //----------
        .then((response) => {
          commit('setArenas', response.data.results)
          resolve(response.data.results)
        })
        //-------------
        // where error
        //-------------
        .catch((error) => {
          reject(error)
        })
    })
  },
  //===============================================================
  // load config
  //-------------
  async loadConfig({ commit, state }) {
    const configEndpoint = 'api/v1/campaigns/config/'
    const appSettingsEndpoint = 'api/v1/campaigns/settings/'
    const headers = state.headers
    await Promise.all([
      axios.get(configEndpoint, {
        headers: headers,
        mode: 'same-origin',
      }),
      axios.get(appSettingsEndpoint, {
        headers: headers,
        mode: 'same-origin',
      }),
    ])
      .then(([configResponse, appSettingsResponse]) => {
        commit('setConfig', configResponse.data)
        commit('setAppSettings', appSettingsResponse.data)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // load campaign log
  //----------------
  async loadCampaignLog({ state }, arena_slug) {
    return new Promise((resolve, reject) => {
      const endpoint = 'api/v1/campaigns/' + arena_slug + '/log/'
      const headers = state.headers
      axios
        .get(endpoint, {
          headers: headers,
          mode: 'same-origin',
        })
        //--------------
        // where api ok
        //--------------
        .then((response) => {
          resolve(response.data.results)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //===============================================================
  // create campaign log
  //------------------
  async createCampaignLog({ state }, payload) {
    return new Promise((resolve, reject) => {
      const endpoint = 'api/v1/campaigns/create-log/'
      const headers = state.headers
      axios({
        method: 'post',
        headers: headers,
        url: endpoint,
        data: payload,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response.data)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //===============================================================
  // clear arena log
  //-----------------
  async clearArenaLog({ state }, arena_slug) {
    // clear campaign log
    const endpoint = 'api/v1/campaigns/' + arena_slug + '/clear-log/'
    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios
        .delete(endpoint, {
          headers: headers,
          mode: 'same-origin',
        })
        .then(() => {
          resolve()
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //===============================================================
  // load static markers
  //---------------------
  async loadStaticMarkers({ commit, state }) {
    const endpoint = 'api/v1/markers/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setMarkers', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // load static options
  //---------------------
  async loadStaticOptions({ commit, state }) {
    const endpoint = 'api/v1/options/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setOptions', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // load static statuses
  //----------------------
  async loadStaticStatuses({ commit, state }) {
    const endpoint = 'api/v1/statuses/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setStatuses', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // load static visibilities
  //--------------------------
  async loadStaticVisibilities({ commit, state }) {
    const endpoint = 'api/v1/visibilities/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setVisibilities', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // load static fatigues
  //----------------------
  async loadStaticFatigues({ commit, state }) {
    const endpoint = 'api/v1/fatigues/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setFatigues', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // load static actions
  //---------------------
  async loadStaticActions({ commit, state }) {
    const endpoint = 'api/v1/actions/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setActions', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // load static reactions
  //-----------------------
  async loadStaticReactions({ commit, state }) {
    const endpoint = 'api/v1/reactions/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setReactions', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // load static roles
  //-------------------
  async loadStaticRoles({ commit, state }) {
    const endpoint = 'api/v1/roles/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setRoles', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // load campaign
  //------------
  async loadCampaign({ commit, state }, slug) {
    const endpoint = 'api/v1/campaigns/' + slug + '/'
    const headers = state.headers
    return new Promise((resolve, reject) => {
      axios
        .get(endpoint, {
          headers: headers,
          mode: 'same-origin',
        })
        //--------------
        // where api ok
        //--------------
        .then((response) => {
          commit('setArena', response.data)
          resolve(response.data)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //===============================================================
  // load campaign round actions
  //--------------------------
  async loadCampaignRoundActions({ state }, parm) {
    return new Promise((resolve, reject) => {
      console.log('off to get actions...')
      const endpoint = 'api/v1/campaigns/' + parm.slug + '/actions/' + parm.round + '/'
      const headers = state.headers
      axios
        .get(endpoint, {
          headers: headers,
          mode: 'same-origin',
        })
        //--------------
        // where api ok
        //--------------
        .then((response) => {
          // console.log("combat back from call - response")
          resolve(response.data.results)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          // console.log("combat back from call - error = " + err)
          reject(err)
        })
    })
  },
  //===============================================================
  // load campaign round reactions
  //----------------------------
  async loadCampaignRoundReactions({ state }, parm) {
    return new Promise((resolve, reject) => {
      console.log('off to get reactions...')
      const endpoint = 'api/v1/campaigns/' + parm.slug + '/reactions/' + parm.round + '/'
      const headers = state.headers
      axios
        .get(endpoint, {
          headers: headers,
          mode: 'same-origin',
        })
        //--------------
        // where api ok
        //--------------
        .then((response) => {
          // console.log("combat back from call - response")
          resolve(response.data.results)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          // console.log("combat back from call - error = " + err)
          reject(err)
        })
    })
  },
  //===============================================================
  // load campaign round markers
  //--------------------------
  async loadCampaignRoundMarkers({ state }, parm) {
    return new Promise((resolve, reject) => {
      console.log('off to get markers...')
      const endpoint = 'api/v1/campaigns/' + parm.slug + '/markers/' + parm.round + '/'
      const headers = state.headers
      axios
        .get(endpoint, {
          headers: headers,
          mode: 'same-origin',
        })
        //--------------
        // where api ok
        //--------------
        .then((response) => {
          // console.log("combat back from call - response")
          resolve(response.data.results)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          // console.log("combat back from call - error = " + err)
          reject(err)
        })
    })
  },
  //===============================================================
  // load campaign players
  //--------------------
  async loadCampaignPlayers({ commit, state }, slug) {
    const endpoint = 'api/v1/campaigns/' + slug + '/players/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setArenaPlayers', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // edit combatant (add/change)
  //-----------------------------
  editCombatant({ commit, state }, parm) {
    //   console.log("----------------------------------");
    //   console.log("IN COMBAT editCombatant...");
    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios({
        method: parm.api_request.method,
        url: parm.api_request.endpoint,
        headers: headers,
        data: parm.payload,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          //------------------------
          // add combatant to store
          //------------------------
          if (parm.api_request.method == 'POST') {
            commit('setAddCombatant', response.data)
            //---------------------------
            // update combatant in store  (could include get/refresh)
            //---------------------------
          } else {
            commit('setUpdateCombatant', response.data)
          }
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //===============================================================
  // edit campaign progress
  //---------------------
  editCampaignProgress({ commit, state }, progress) {
    // console.log("----------------------------------");
    // console.log("IN COMBAT editArenaProgress...");
    return new Promise((resolve, reject) => {
      const endpoint = 'api/v1/campaigns/' + progress.slug + '/progress/'
      const headers = state.headers
      axios({
        method: 'patch',
        url: endpoint,
        headers: headers,
        data: progress.payload,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          //--------------------------------
          // update arena progress in store
          //--------------------------------
          commit('setArenaProgress', response.data)
          //----------------------------------------
          // update arena lock status where changed
          //----------------------------------------
          if (Object.hasOwn(response.data, 'locked')) {
            let lock_state = response.data['locked']
            let arena_idx = state.arenas.findIndex((a) => a.id == response.data['id'])
            if (arena_idx != -1) {
              if (lock_state != state.arenas[arena_idx].locked) {
                let lock_parm = {
                  idx: arena_idx,
                  lock_state: lock_state,
                }
                commit('setArenaLocked', lock_parm)
              }
            }
          }

          resolve(response.data)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //===============================================================
  // clear campaign combatants
  //------------------------
  clearCampaignCombatants({ commit, state }, arena_slug) {
    return new Promise((resolve, reject) => {
      const endpoint = 'api/v1/campaigns/' + arena_slug + '/clear/'
      const headers = state.headers
      axios
        .delete(endpoint, {
          headers: headers,
          mode: 'same-origin',
        })
        //----------
        // where ok
        //----------
        .then(() => {
          //---------------------------
          // clear combatants in store
          //---------------------------
          commit('setClearArenaCombatants')
          resolve()
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //===============================================================
  // change combatant image (patch)
  //--------------------------------
  changeCombatantImage({ commit }, parm) {
    // console.log("--------------------")
    // console.log("IN changeCombatantImage")
    const endpoint = 'api/v1/combatants/' + parm.slug + '/image/'

    return new Promise((resolve, reject) => {
      axios({
        method: 'patch',
        url: endpoint,
        headers: { 'content-type': 'multipart/form-data' },
        data: parm.image_file,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          commit('setUpdateCombatantImage', response.data)
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //=================================================================
  // copy combatant image (patch) [from character during deployment]
  //-----------------------------
  copyCombatantImage({ commit }, parm) {
    const headers = state.headers
    const endpoint = 'api/v1/combatants/' + parm.slug + '/copyimage/'

    let data = {
      image: parm.image_file,
    }

    return new Promise((resolve, reject) => {
      axios({
        method: 'patch',
        url: endpoint,
        headers: headers,
        data: data,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          commit('setUpdateCombatantImage', response.data)
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //===============================================================
  // delete combatant
  //------------------
  deleteCombatant({ commit }, slug_request) {
    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios({
        method: slug_request.request.method,
        url: slug_request.request.endpoint,
        headers: headers,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          commit('setDeleteCombatant', slug_request.slug)
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((error) => {
          reject(error)
        })
    })
  },
  //===============================================================
  // delete slot
  //-------------
  deleteSlot(_, request) {
    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios({
        method: request.method,
        url: request.endpoint,
        headers: headers,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((error) => {
          reject(error)
        })
    })
  },
  //===============================================================
  // delete combatant slots
  //------------------------
  deleteCombatantSlots(_, endpoint) {
    return new Promise((reject) => {
      const headers = state.headers
      axios({
        method: 'DELETE',
        url: endpoint,
        headers: headers,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then(() => {})
        //-----------------
        // where api error
        //-----------------
        .catch((error) => {
          reject(error)
        })
    })
  },
  //===============================================================
  // view combatant slots
  //----------------------
  viewCombatantSlots(_, request) {
    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios({
        method: request.method,
        url: request.endpoint,
        headers: headers,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          console.log('IN COMBAT viewCombatantSlots response = ', response.data)
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((error) => {
          console.log('ERROR = ' + error)
          reject(error)
        })
    })
  },
  //===============================================================
  // edit combat action (add/change)
  //---------------------------------
  editCombatAction({ state }, parm) {
    console.log('IN COMBAT editCombatAction parm = ', parm)
    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios({
        method: parm.api_request.method,
        url: parm.api_request.endpoint,
        headers: headers,
        data: parm.payload,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          console.log('IN COMBAT editCombatAction response = ', response.data)
          resolve(response.data)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          console.log('IN COMBAT editCombatAction error = ', err)
          reject(err)
        })
    })
  },
  //===============================================================
  // view round action counts
  //--------------------------
  viewRoundActionCounts({ state }, parm) {
    return new Promise((reject, resolve) => {
      const endpoint = 'api/v1/campaigns/' + parm.arena_slug + '/actions/' + parm.round + '/counts/'
      const headers = state.headers
      axios
        .get(endpoint, {
          headers: headers,
          mode: 'same-origin',
        })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response.data.results)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //===============================================================
  // view combatant action counts
  //------------------------------
  viewCombatantActionCounts({ state }, parm) {
    return new Promise((reject, resolve) => {
      const endpoint =
        'api/v1/combatants/' + parm.combatant_slug + '/actions/' + parm.round + '/counts/'
      const headers = state.headers
      axios
        .get(endpoint, {
          headers: headers,
          mode: 'same-origin',
        })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response.data.results)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //===============================================================
  // view extra attacks
  //--------------------
  viewExtraAttacks({ state }, parm) {
    return new Promise((reject, resolve) => {
      const endpoint = 'api/v1/campaigns/' + parm.arena_slug + '/extraattacks/' + parm.round + '/'
      const headers = state.headers
      axios
        .get(endpoint, {
          headers: headers,
          mode: 'same-origin',
        })
        //----------
        // where ok
        //----------
        .then((response) => {
          //---------------------------
          // clear combatants in store
          //---------------------------
          resolve(response.data.results)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //===============================================================
  // edit combat reaction (add/change)
  //-----------------------------------
  editCombatReaction({ state }, parm) {
    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios({
        method: parm.api_request.method,
        url: parm.api_request.endpoint,
        headers: headers,
        data: parm.payload,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response.data)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
  //===============================================================
  // edit combat marker (add/change)
  //---------------------------------
  editCombatMarker({ state }, parm) {
    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios({
        method: parm.api_request.method,
        url: parm.api_request.endpoint,
        headers: headers,
        data: parm.payload,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response.data)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((err) => {
          reject(err)
        })
    })
  },
}
//===============================================================
// mutations
//-----------
const mutations = {
  setCurrentActionNumber(state, payload) {
    state.current_action_number = payload
  },
  setUnusedActionCount(state, payload) {
    state.unused_action_count = payload
  },
  setArenas(state, payload) {
    state.arenas.push(...payload)
  },
  setArenaLocked(state, payload) {
    if (state.arenas[payload.idx]) {
      state.arenas[payload.idx].locked = payload.lock_state
    }
  },
  setArena(state, payload) {
    state.arena = payload
  },
  setClearArenaCombatants(state) {
    state.arena.arena_combatants = []
  },
  setActiveCombatantCount(state, payload) {
    state.arena.active_combatant_count = payload
  },
  setInactiveCombatantCount(state, payload) {
    state.arena.inactive_combatant_count = payload
  },
  setConfig(state, payload) {
    state.config = payload
  },
  setAppSettings(state, payload) {
    state.appSettings = payload
  },
  setViewRound(state, payload) {
    state.view_round = payload
  },
  setArenaSubStatus(state, payload) {
    state.arena_sub_status = payload || ''
  },
  setStatuses(state, payload) {
    state.statuses = payload
  },
  setMarkers(state, payload) {
    state.markers = payload
  },
  setOptions(state, payload) {
    state.options = payload
  },
  setVisibilities(state, payload) {
    state.visibilities = payload
  },
  setFatigues(state, payload) {
    state.fatigues = payload
  },
  setActions(state, payload) {
    state.actions = payload
  },
  setReactions(state, payload) {
    state.reactions = payload
  },
  // setRaces(state, payload) {
  //   state.races = payload;
  // },
  setRoles(state, payload) {
    state.roles = payload
  },
  setArenaPlayers(state, payload) {
    state.players = payload
  },
  setArenaProgress(state, payload) {
    state.arena.status = payload.status
    state.arena.round = payload.round
    state.arena.action = payload.action
    state.arena.locked = payload.locked
    state.arena.rolled = payload.rolled
    state.arena.in_progress = payload.in_progress
    state.arena.round_completed = payload.round_completed
    state.arena.ended = payload.ended
  },
  setAddCombatant(state, payload) {
    state.arena.arena_combatants.push(payload)
    //-------------------------
    // refresh combatant order
    //-------------------------
    state.arena.arena_combatants = refreshCombatantOrder(state.arena.arena_combatants)
  },
  setUpdateCombatant(state, payload) {
    const idx = state.arena.arena_combatants.map((i) => i.id).indexOf(payload.id)
    state.arena.arena_combatants[idx] = payload
    //-------------------------
    // refresh combatant order
    //-------------------------
    state.arena.arena_combatants = refreshCombatantOrder(state.arena.arena_combatants)
  },
  setDeleteCombatant(state, slug) {
    state.arena.arena_combatants = state.arena.arena_combatants.filter((c) => c.slug !== slug)
    //-------------------------
    // refresh combatant order
    //-------------------------
    console.log('r11')

    state.arena.arena_combatants = refreshCombatantOrder(state.arena.arena_combatants)
  },
  setUpdateCombatantImage(state, payload) {
    const idx = state.arena.arena_combatants.map((i) => i.slug).indexOf(payload.slug)
    state.arena.arena_combatants[idx].image = payload.image
  },
  setCombatants(state, payload) {
    state.combatants = payload
    //-------------------------
    // refresh combatant order
    //-------------------------
    console.log('r12')

    state.arena.arena_combatants = refreshCombatantOrder(state.arena.arena_combatants)
  },
  setPlayerNames(state, payload) {
    state.player_names = payload
  },
}
//===============================================================
// export
//--------
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
